/* eslint-disable */
import bi1_data_validation from '../../base_i1_datavalidation'
import { RC, CR, AJRS } from '../../base_i2_success_codes'
import base_i3_log from '../../base_i3_logging'
import { ajax } from 'noquery-ajax'

function getNotificationGroupUsers(firebase_email, firebase_token, ngp_uids) {
    return new Promise(function (resolve, reject) {
        var return_msg = "";
        var debug_data = [];
        var call_result = {};
        var task_id = "p2s7t10getNotificationGroupUsers";
        var group_users = {};

        ///// input validation
        call_result = bi1_data_validation.is_email_address(firebase_email);
        debug_data.push(call_result);
        call_result = bi1_data_validation.is_string(firebase_token);
        debug_data.push(call_result);
        call_result = bi1_data_validation.is_array(ngp_uids);
        debug_data.push(call_result);

        var validation_failed_flag = false;
        for (var index in debug_data) {
          if (debug_data[index][CR.success] != RC.success) {
            validation_failed_flag = true;
            break;
          }
        }

        if (validation_failed_flag == true) {
          return_msg += "input validation failed";
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
          reject({ success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data, group_users: group_users });
        }
        /////</end> input validation

        var params = {
          'p2s7_firebase_email': firebase_email,
          'p2s7_token': firebase_token,
          'p2s7t10_group_list': JSON.stringify(ngp_uids)
        }

        ajax({
            url: window.G_ajax_test_domain + '/json-requests/p2s7t10-get-notification-group-users',
            method: 'POST',
            data: params,
            success: function (result) {
              group_users = result;
              resolve({ success: RC.general_failure, return_msg: return_msg, debug_data: debug_data, group_users: group_users});
            },
            error: function (err) {
              if (err.status == 401) {
                window.G_firebase_auth.bi5forceTokenRefresh();
              }
              return_msg += "Failed to get notification group users data, error data:" + JSON.stringify(err);
              base_i3_log(G_username, G_ip, G_page_id, task_id, RC.ajax_failure, return_msg, debug_data);
              reject({ success: RC.general_failure, return_msg: return_msg, debug_data: debug_data, group_users: group_users});
            }
        })

    });
};

export default getNotificationGroupUsers 



// WEBPACK FOOTER //
// ./src/watchdog_includes/json_tasks/p2s7/p2s7t10.js